export enum PageHeaderType {
  // eslint-disable-next-line no-unused-vars
  DEFAULT = 'default',
  // eslint-disable-next-line no-unused-vars
  UNDERLINE = 'underline',
  // eslint-disable-next-line no-unused-vars
  CIRCLE = 'circle',
}
